import { BiRightArrowAlt } from 'react-icons/bi'
import type { NavItem } from '../types'

export const documentation: NavItem = {
  name: 'Documentation',
  linkSections: [
    {
      columns: 1,
      sections: [
        {
          header: 'Documentation',
          items: [
            { name: 'Install', href: '/install' },
            {
              name: 'PennyLane documentation',
              href: 'https://docs.pennylane.ai/en/stable/',
            },
            {
              name: 'Catalyst documentation',
              href: 'https://docs.pennylane.ai/projects/catalyst/en/stable/',
            },
            {
              name: 'Development guide',
              href: 'https://docs.pennylane.ai/en/stable/development/guide.html',
            },
            {
              name: 'How-to guides',
              href: '/search/?contentType=DEMO&categories=how-to&sort=publication_date',
            },
            {
              name: 'API',
              href: 'https://docs.pennylane.ai/en/stable/code/qp.html',
            },
            {
              name: 'GitHub',
              href: 'https://github.com/PennyLaneAI/pennylane',
            },
          ],
        },
      ],
    },
  ],
  cardSections: [
    {
      header: 'Getting Started',
      type: 'featured',
      cards: [
        {
          variant: 'white',
          title: 'PennyLane Fundamentals',
          description: `Begin with a crash course on the basics of PennyLane for quantum practitioners.`,
          imageSrc:
            'https://assets.cloud.pennylane.ai/navbar/documentation-fundamentals-wide.png',
          imageSize: 'full',
          button: {
            text: 'Get started',
            variant: 'secondary',
          },
          href: '/codebook/pennylane-fundamentals',
        },
        {
          variant: 'white',
          title: 'Documentation',
          description: `Explore our quantum software API references and development guides.`,
          imageSrc:
            'https://assets.cloud.pennylane.ai/navbar/documentation-documentation-wide.png',
          imageSize: 'full',
          button: {
            text: 'View documentation',
            variant: 'primary',
          },
          href: 'https://docs.pennylane.ai/en/stable/',
        },
      ],
    },
    {
      header: 'Latest Release',
      type: 'release',
      cards: {
        limit: 1,
        variant: 'primary-blue',
        button: {
          text: 'New in this release',
          variant: 'secondary',
          icon: BiRightArrowAlt,
        },
      },
    },
  ],
}
